import { useAuth } from '../../contexts/AuthContext';
import { LogOut, FolderPen, ChartCandlestick, BookCheck, X, Swords } from 'lucide-react';
import { openGuidePopup } from '../../utils/openGuidePopup';
import ThemeToggle from "../../components/ThemeToggle";
import Logo from "../../components/Logo";
import KakaoAdFit from "../../components/KakaoAdfit";

export default function Sidebar({ mode = 'desktop', open = false, onClose }) {
  const { user, signIn, signOutFn, ready } = useAuth();

  // 공통 네비 내부 (모바일/데스크톱에서 공유)
  const NavBody = (
    <nav className="flex h-full flex-col">
      {/* Top account/menu */}
        {mode !== 'drawer' && (
          <div className="border-b border-zinc-950/5 dark:border-white/10 p-4 flex items-center">
          <a
            href="/"
            className="flex flex-1 items-center gap-3 rounded-lg px-2 py-2.5 text-base font-semibold text-zinc-900 focus-visible:outline-none dark:text-zinc-100"
          >
            <span className="truncate">
              <Logo className="h-6 w-auto text-zinc-900 dark:text-white" />
            </span>
          </a>
          <ThemeToggle className="ml-2" />
          </div>
        )}
        {/* 모바일 드로어 닫기 버튼 */}
        {mode === 'drawer' && (
          <div className='w-full h-14 flex items-center'>
            <button
              onClick={onClose}
              className="ml-auto mr-3 inline-flex lg:hidden w-9 h-9 items-center justify-center rounded-lg border border-zinc-950/10 bg-white text-zinc-700 hover:bg-zinc-50 dark:border-zinc-300/10 dark:bg-zinc-800 dark:text-zinc-200"
              aria-label="메뉴 닫기"
            >
              <X size={18} />
            </button>
          </div>
        )}

      {/* Nav sections */}
      <div className="flex flex-1 flex-col overflow-y-auto p-4 sidebar-hidden">

        <div className="hidden lg:flex flex-col gap-0.5">
          <button
            type="button"
            onClick={openGuidePopup}
            className="group flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/6 font-medium text-zinc-700 hover:bg-zinc-950/5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900/20 dark:text-zinc-300 dark:hover:bg-white/5 dark:focus-visible:ring-white/20"
          >
            <BookCheck size="16" className="text-zinc-500 group-hover:text-zinc-900 dark:group-hover:text-white" />
            <span className="truncate">가이드</span>
          </button>
        </div>

        <div className="flex flex-col gap-0.5">
          <a
            href="/my"
            className="group flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/6 font-medium text-zinc-700 hover:bg-zinc-950/5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900/20 dark:text-zinc-300 dark:hover:bg-white/5 dark:focus-visible:ring-white/20"
          >
            <FolderPen size="16" className="text-zinc-500 group-hover:text-zinc-900 dark:group-hover:text-white" />
            <span className="truncate">내 전투 분석 기록</span>
          </a>
        </div>

        <div className="flex flex-col gap-0.5">
          <a
            href="/stats"
            className="group flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/6 font-medium text-zinc-700 hover:bg-zinc-950/5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900/20 dark:text-zinc-300 dark:hover:bg-white/5 dark:focus-visible:ring-white/20"
          >
            <ChartCandlestick size="16" className="text-zinc-500 group-hover:text-zinc-900 dark:group-hover:text-white" />
            <span className="truncate">전투 분석 통계</span>
          </a>
        </div>

        <div className="flex flex-col gap-0.5">
          <a
            href="/lobby"
            className="group flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/6 font-medium text-zinc-700 hover:bg-zinc-950/5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900/20 dark:text-zinc-300 dark:hover:bg-white/5 dark:focus-visible:ring-white/20"
          >
            <Swords size="16" className="text-zinc-500 group-hover:text-zinc-900 dark:group-hover:text-white" />
            <span className="truncate">공격대 전투 분석</span>
          </a>
        </div>

        <div className="mt-auto -mb-5">
          <KakaoAdFit unit="DAN-Uyyk4O8NizlZFmbh" width={224} height={224} />
        </div>

        



        <div className="flex flex-col gap-0.5">
          <a
            href="/faq"
            className="flex items-center gap-3 rounded-lg px-2 py-2.5 text-base font-medium text-zinc-700 hover:bg-zinc-950/5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900/20 dark:text-zinc-300 dark:hover:bg-white/5 dark:focus-visible:ring-white/20"
          >
            <span className="truncate">FAQ</span>
          </a>
        </div>
        <div className="flex flex-col gap-0.5">
          <a
            href="/report"
            className="flex items-center gap-3 rounded-lg px-2 py-2.5 text-base font-medium text-zinc-700 hover:bg-zinc-950/5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900/20 dark:text-zinc-300 dark:hover:bg-white/5 dark:focus-visible:ring-white/20"
          >
            <span className="truncate">오류 제보</span>
          </a>
        </div>
      </div>

      {/* Footer user */}
      <div className="border-t border-zinc-950/5 dark:border-white/10 p-4">
        {!ready ? null : user ? (
          <div className="flex w-full items-center justify-between rounded-lg px-2 py-2.5 text-base font-medium text-zinc-900 dark:text-zinc-100">
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-zinc-900 dark:text-zinc-100">{user.displayName}</span>
              <span className="block truncate text-xs text-zinc-500 font-numeric tabular-nums">{user.email}</span>
            </span>
            <button
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-white text-zinc-900 border border-zinc-950/10 hover:bg-zinc-950/[0.025] active:bg-zinc-950/[0.035] transition-colors dark:bg-zinc-800 dark:text-zinc-100 dark:border-white/10 dark:hover:bg-white/10 dark:active:bg-white/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900/20 dark:focus-visible:ring-white/20"
              onClick={signOutFn}
              aria-label="로그아웃"
              title="로그아웃"
            >
              <LogOut size={16} />
            </button>
          </div>
        ) : (
          <div className="flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-base font-medium">
            <button
              onClick={signIn}
              className="w-full h-9 text-sm flex items-center justify-center rounded text-zinc-700 hover:bg-zinc-950/[0.025] active:bg-zinc-950/[0.035] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900/20 dark:text-zinc-300 dark:hover:bg-white/10 dark:active:bg-white/15 dark:focus-visible:ring-white/20"
            >
              Google 로그인
            </button>
          </div>
        )}
      </div>
    </nav>
  );

  // 데스크톱 사이드바
  if (mode === 'desktop') {
    return (
      <aside className="hidden lg:fixed lg:inset-y-0 lg:left-0 lg:w-64 lg:block">
        {NavBody}
      </aside>
    );
  }

  // 모바일 드로어 (오버레이)
  return (
    <div className={`lg:hidden fixed inset-0 z-50 ${open ? '' : 'pointer-events-none'}`}>
      <div
        className={`absolute inset-0 bg-black/40 transition-opacity ${open ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
      />
      <aside
        className={`absolute left-0 top-0 h-full w-72 max-w-[85%] bg-white dark:bg-zinc-900 shadow-xl transition-transform ${open ? 'translate-x-0' : '-translate-x-full'}`}
        role="dialog"
        aria-modal="true"
      >
        {NavBody}
      </aside>
    </div>
  )
}
